var _desc, _defs, _rect, _path, _rect2, _path2, _path3, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverCutRacing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 720 960",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "OverCutRacing") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Racing draft card with track, cars and championship podium")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paper",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffdf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebe3d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "track",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d7b46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174d2d"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 960,
    fill: "url(#paper)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 660 C150 600 230 650 360 595 C500 535 590 555 720 500 L720 960 L0 960 Z",
    fill: "#071711",
    opacity: 0.08
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 110,
    width: 544,
    height: 628,
    rx: 24,
    fill: "url(#track)",
    stroke: "#d6a945",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150 170 C370 70 580 210 495 390 C435 520 245 440 255 610 C265 790 560 705 590 805",
    fill: "none",
    stroke: "#ffffff",
    strokeOpacity: 0.82,
    strokeWidth: 34,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150 170 C370 70 580 210 495 390 C435 520 245 440 255 610 C265 790 560 705 590 805",
    fill: "none",
    stroke: "#071711",
    strokeOpacity: 0.35,
    strokeWidth: 4,
    strokeDasharray: "28 28",
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(158 236)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 54,
    rx: 12,
    fill: "#ff553c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 52,
    r: 12,
    fill: "#071711"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 52,
    r: 12,
    fill: "#071711"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 10,
    width: 42,
    height: 22,
    rx: 6,
    fill: "#fffdf8",
    opacity: 0.72
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(425 520)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 56,
    rx: 12,
    fill: "#d6a945"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 54,
    r: 13,
    fill: "#071711"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 54,
    r: 13,
    fill: "#071711"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 10,
    width: 42,
    height: 22,
    rx: 6,
    fill: "#fffdf8",
    opacity: 0.72
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#071711"
  }, /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 835,
    fontFamily: "Impact, Arial Black, sans-serif",
    fontSize: 70
  }, "OVERCUT"), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 900,
    fontFamily: "Impact, Arial Black, sans-serif",
    fontSize: 70,
    fill: "#ff553c"
  }, "RACING"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(468 116)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 72,
    width: 56,
    height: 76,
    rx: 6,
    fill: "#fffdf8",
    stroke: "#071711",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 38,
    width: 56,
    height: 110,
    rx: 6,
    fill: "#fffdf8",
    stroke: "#071711",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 0,
    width: 56,
    height: 148,
    rx: 6,
    fill: "#fffdf8",
    stroke: "#071711",
    strokeWidth: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverCutRacing);
export default __webpack_public_path__ + "static/media/OverCutRacing.e8d8eb3ab05a632a1e5bd8e0cb7e7558.svg";
export { ForwardRef as ReactComponent };